import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';

export const userRequests = {}

userRequests.RegisterChangePassword = (data) => {
  return axios.post(
    AppUrls.RegisterChangePassword,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

userRequests.RecoverChangePassword = (data) => {
  return axios.post(
    AppUrls.RecoverChangePassword,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

let handleResponse = (response) => {
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    let error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}